import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'

import { RootEpic } from '../types'
import { getTradingHistoryRequest, getTradingHistorySuccess, getTradingHistoryFailure } from '../actions'

export const fetchTradingHistoryEpic: RootEpic = (action$, state$, { fetchTradingHistory }) =>
  action$.pipe(
    filter(isActionOf([getTradingHistoryRequest])),
    switchMap(({ payload }) =>
      from(fetchTradingHistory({ ...payload, token: state$.value.app.authToken as string })).pipe(
        map((response) => getTradingHistorySuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch trading history.')
          return of(getTradingHistoryFailure(message))
        }),
      ),
    ),
  )

export default [fetchTradingHistoryEpic]
